import React from 'react';
import { Form, InputNumber, Divider } from 'antd';
import { configShort } from '../../../../../common/utils/configFormField';

class Section4 extends React.Component {
  // constructor(props) {
  //     super(props);
  // }

  render() {
    const { getFieldDecorator } = this.props.form;
    const { fields, disabledFields } = this.props;
    return (
      <div className="sectionDeadline">
        <Divider />
        <h1 className="header">
          Срок опоздания, при превышении которого заказчик, фрахтователь создал
          невозможность исполнения
          <br />
          фрахтовщиком своего обязательства (влечет возможность отказа от
          договора и право
          <br />
          на возмещение убытков от фрахтователя)
        </h1>
        <div className="colsLayout">
          <span className="label">
            Неявка заказчика (всех пассажиров)
            <br />
            на место посадки (Ш2), мин:
          </span>
          <Form.Item>
            {getFieldDecorator('section4_1', configShort(fields['section4_1']))(
              <InputNumber
                className="basicInput"
                placeholder="Укажите"
                disabled={disabledFields}
              />
            )}
          </Form.Item>
          <span className="label">
            Непредоставление необходимых для осуществления
            <br />
            перевозки документов (кроме ОПГД) (Ш2), час:
          </span>
          <Form.Item>
            {getFieldDecorator('section4_2', configShort(fields['section4_2']))(
              <InputNumber
                className="basicInput"
                placeholder="Укажите"
                disabled={disabledFields}
              />
            )}
          </Form.Item>
          <span className="label">
            Непредоставление необходимых для осуществления
            <br />
            перевозки документов (для ОПГД) (Ш2), час:
          </span>
          <Form.Item>
            {getFieldDecorator('section4_3', configShort(fields['section4_3']))(
              <InputNumber
                className="basicInput"
                placeholder="Укажите"
                disabled={disabledFields}
              />
            )}
          </Form.Item>
          <span className="label">
            Неявка заказчика (всех пассажиров) на посадку
            <br />в промежут. пункте для продолжения перевозки (Ш2), мин:
          </span>
          <Form.Item>
            {getFieldDecorator('section4_4', configShort(fields['section4_4']))(
              <InputNumber
                className="basicInput"
                placeholder="Укажите"
                disabled={disabledFields}
              />
            )}
          </Form.Item>
        </div>
      </div>
    );
  }
}

export default Section4;
